var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insiderBox",style:({ backgroundColor: _vm.bgColor && _vm.bgColor })},[_vm._v(" "+_vm._s(_vm.iName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }